import EventBus from '@/eventbus.js'

const md5 = require('md5')

const moment = require('moment')
const pako = require('pako')
// const s = require('@/security.js')
export const socketInputMixin = {
  data() {
    return {
      newMessageSound: undefined
    }
  },

  methods: {
    dec(data) {
      let key = '0a34e8b3-d947-4379-a289-de33e8e2ac94'
      let iv = key
        .split('')
        .reverse()
        .join('')
      return this.dwk(JSON.stringify(data), key, iv)
    },
    buildWebSocket() {
      if (this.$store.state.socket.connection !== null && this.$store.state.socket.connection.readyState !== 3) {
        return
      }

      var sec = md5('spexmesaj' + this.$store.state.session.user.UserID + 'browser')
      var url = this.$store.state.socket.baseUrl + '?userid=' + this.$store.state.session.user.UserID + '&sec=' + sec + '&token=' + this.$store.state.session.user.Token + '&source=browser'

      let vm = this
      this.$store.state.socket.url = url

      this.$store.state.socket.connection = new WebSocket(url)
      this.$store.state.socket.connection.binaryType = 'arraybuffer'
      this.$store.state.socket.connection.onopen = () => {
        vm.socketOpened()
      }
      this.$store.state.socket.connection.onclose = () => {
        vm.socketClosed()
      }
      this.$store.state.socket.connection.onerror = error => {
        vm.socketError(error)
      }
      this.$store.state.socket.connection.onmessage = data => {
        vm.socketMessageReceived(data)
      }
    },

    rebuildWebSocket() {
      if (!this.$store.state.socket.shouldReconnect) {
        return
      }

      let vm = this
      this.$store.state.socket.connection = null
      var url = this.$store.state.socket.url

      this.$store.state.socket.connection = new WebSocket(url)
      this.$store.state.socket.connection.binaryType = 'arraybuffer'
      this.$store.state.socket.connection.onopen = () => {
        vm.socketOpened()
      }
      this.$store.state.socket.connection.onclose = () => {
        vm.socketClosed()
      }
      this.$store.state.socket.connection.onerror = error => {
        vm.socketError(error)
      }
      this.$store.state.socket.connection.onmessage = data => {
        vm.socketMessageReceived(data)
      }
    },

    socketOpened() {
      EventBus.$emit('log', {
        type: 'warn',
        text: 'Socket opened'
      })
      this.$store.state.socket.reconnectTimer = 1
      if (this.$store.state.socket.reconnectTimeout !== null) {
        clearTimeout(this.$store.state.socket.reconnectTimeout)
        this.$store.state.socket.reconnectTimeout = null
      }
    },

    socketClosed() {
      EventBus.$emit('log', {
        type: 'info',
        text: 'Socket closed'
      })

      if (!this.$store.state.socket.shouldReconnect) {
        return
      }

      if (this.$store.state.socket.reconnectTimer <= 30) {
        this.$store.state.socket.reconnectTimer = this.$store.state.socket.reconnectTimer * 2
      }

      if (this.$store.state.socket.reconnectTimeout !== null) {
        clearTimeout(this.$store.state.socket.reconnectTimeout)
      }

      this.$store.state.socket.reconnectTimeout = setTimeout(() => {
        this.$store.state.socket.reconnectTimeout = null
        this.rebuildWebSocket()
      }, Math.min(this.$store.state.socket.maxReconnectTimer * 1000, this.$store.state.socket.reconnectTimer * 1000))
    },

    socketError(event) {
      EventBus.$emit('log', {
        type: 'info',
        text: 'Socket hata'
      })
    },
    socketMessageReceived(event) {
      EventBus.$emit('log', {
        type: 'info',
        text: 'Socket mesaj alındı'
      })

      if (event.data instanceof ArrayBuffer) {
        this.processCompressedWebSocketInput(event.data)
        return
      }

      if (typeof Blob !== 'undefined' && event.data instanceof Blob) {
        var reader = new FileReader()
        reader.onload = () => this.processCompressedWebSocketInput(reader.result)
        reader.onerror = () => {
          EventBus.$emit('log', {
            type: 'error',
            text: 'Sıkıştırılmış socket mesajı okunamadı'
          })
        }
        reader.readAsArrayBuffer(event.data)
        return
      }

      this.processWebSocketInput(event.data)
    },

    processCompressedWebSocketInput(inputBuffer) {
      try {
        var inputString = pako.ungzip(new Uint8Array(inputBuffer), {
          to: 'string'
        })
        this.processWebSocketInput(inputString)
      } catch (error) {
        EventBus.$emit('log', {
          type: 'error',
          text: 'Sıkıştırılmış socket mesajı çözümlenemedi: ' + error.message
        })
      }
    },

    processWebSocketInput(inputString) {
      var input
      try {
        input = JSON.parse(inputString)
      } catch (error) {
        input = JSON.parse(this.dec(inputString))
      }

      switch (input.Type) {
        case 'result':
          this.processWebSocketResultTypes(input)
          break
        case 'message':
          this.processWebSocketReceivedMessage(input)
          break
        case 'set':
          this.processWebSocketSetTypes(input)
          break
        case 'info':
          this.processWebSocketInfoTypes(input)
          break
        default:
          break
      }
    },
    dec(data) {
      let key = '0a34e8b3-d947-4379-a289-de33e8e2ac94'
      let iv = key
        .split('')
        .reverse()
        .join('')
      return this.dwk(data, key, iv)
    },
    processWebSocketResultTypes(input) {
      if (input.Success === false) {
        switch (input.Error) {
          case 'connected_from_another_device':
            EventBus.$emit('connected_from_another_device')
            break
          case 'invalid_auth':
            EventBus.$emit('invalid_auth_websocket1')
            break
          default:
            break
        }
        return
      }
      var vm = this

      switch (input.Task) {
        case 'login':
          this.processWSTaskLogin(input)
          break
        case 'updated_data':
          this.processWSTaskUpdatedData(input)
          break
        case 'get_settings':
          vm.processGetSettings(input)
          break
        case 'get_stars':
          vm.processGetStars(input)
          break
        default:
          break
      }
    },

    processWebSocketSetTypes(input) {
      switch (input.Task) {
        case 'start_typing':
          this.processWSSetTaskTyping(input)
          break
        case 'stop_typing':
          this.processWSSetTaskTyping(input)
          break
        case 'group_make_admin':
          this.processWSMakeAdmin(input)
          break
        case 'group_remove_admin':
          this.processWSRemoveAdmin(input)
          break
        case 'clear_chat':
          this.processClearChat(input)
          break
        case 'ums':
          this.processWSSetUpdateMessageStatus(input)
          break
        case 'delete_message':
          this.processWSSetDeleteMessage(input)
          break
        case 'delete_messages':
          this.processWSSetDeleteMessages(input)
          break
        case 'edit_message':
          this.processWSSetEditMessage(input)
          break
        case 'toggle_reaction':
          this.processWSSetToggleReaction(input)
          break
        default:
          break
      }
    },

    processWebSocketInfoTypes(input) {
      switch (input.Task) {
        case 'create_group':
          this.processWSCreateGroup(input)
          break
        case 'update_group':
          this.processWSUpdateGroup(input)
          break
        case 'group_add_participant':
          this.processWSAddParticipant(input)
          break
        case 'group_remove_participant':
          this.processWSRemoveParticipant(input)
          break
        case 'group_make_owner':
          this.processWSMakeOwner(input)
          break
        case 'update_conversation':
          this.processWSSetTaskUpdateConversation(input)
          break
        case 'update_profile':
          this.processWSSetProfileUpdate(input)
          break
        case 'updated_data':
          this.processWSSetUpdatedData(input)
          break
        case 'md':
          this.processWSSetMessageDelivered(input)
          break
        case 'upsert_channel':
          this.processWSUpsertChannel(input)
          break
        default:
          break
      }
    },
    processWSSetUpdatedData(input) {
      this.$store.dispatch('setClearedConversations', input.ClearConversation)
    },
    processWSSetMessageDelivered(input) {
      var message = this.$store.state.message.messages.find(x => x.MessageID === input.mid)
      if (message !== undefined) {
        this.$set(message, 'Status', 1) //iletildi.
      }
    },
    processWSCreateGroup(input) {
      this.$store.dispatch('appendGroup', input.Group)
    },

    processWSUpdateGroup(input) {
      this.$store.commit('updateGroup', input)
    },

    processWSUpsertChannel(input) {
      if (!input.Channel) {
        return
      }
      this.$store.dispatch('appendChannel', input.Channel)
    },

    processWSAddParticipant(input) {
      this.$store.dispatch('addParticipant', input)
    },

    processWSRemoveParticipant(input) {
      this.$store.dispatch('removeParticipant', input)
    },

    processWSMakeAdmin(input) {
      this.$store.dispatch('makeAdmin', input)
    },

    processWSRemoveAdmin(input) {
      this.$store.dispatch('removeAdmin', input)
    },

    processWSMakeOwner(input) {
      this.$store.commit('makeOwner', input)
    },
    processClearChat(input) {
      if (input.isRemove) {
        if (input.isGroup) {
          this.$store.state.group.groups = this.$store.state.group.groups.filter(x => x.GroupID !== input.UniqueID)
          this.$store.state.message.messages = this.$store.state.message.messages.filter(x => x.To !== input.UniqueID)
        } else if (input.ConversationType === 2) {
          this.$store.state.channel.channels = this.$store.state.channel.channels.filter(x => x.ChannelID !== input.UniqueID)
          this.$store.state.message.messages = this.$store.state.message.messages.filter(x => x.To !== input.UniqueID)
        } else {
          this.$store.state.conversation.conversations = this.$store.state.conversation.conversations.filter(x => x.ConversationID !== input.UniqueID)

          this.$store.state.message.messages = this.$store.state.message.messages.filter(x => x.ConversationID !== input.UniqueID)
        }
      } else {
        let item
        if (input.isGroup) {
          item = this.$store.state.group.groups.find(x => x.GroupID !== input.UniqueID)
          item.LastMessage = {}
          this.$store.state.message.messages = this.$store.state.message.messages.filter(x => x.To !== input.UniqueID)
        } else if (input.ConversationType === 2) {
          item = this.$store.state.channel.channels.find(x => x.ChannelID === input.UniqueID)
          if (item) {
            item.LastMessage = {}
          }
          this.$store.state.message.messages = this.$store.state.message.messages.filter(x => x.To !== input.UniqueID)
        } else {
          item = this.$store.state.conversation.conversations.find(x => x.ConversationID !== input.UniqueID)
          item.LastMessage = {}
          this.$store.state.message.messages = this.$store.state.message.messages.filter(x => x.ConversationID !== input.UniqueID)
        }
      }
    },

    processWSSetProfileUpdate(input) {
      let profileToUpdate = this.$store.state.contacts.find(c => c.UserID === input.Data.UserID)
      console.log('input', input)
      if (input.Data === null) {
        profileToUpdate.PhotoURL = input.Data.PhotoURL
        profileToUpdate.StatusText = input.Data.StatusText
        profileToUpdate.VisibleName = input.Data.VisibleName
      } else if (profileToUpdate !== null) {
        profileToUpdate.PhotoURL = ''
        profileToUpdate.StatusText = ''
        profileToUpdate.VisibleName = ''
      } else {

      }

      // If this profile is in conversations tab
      let conversation = this.$store.state.conversation.conversations.find(conv => conv.ContactID === input.Data.UserID)
      if (conversation && conversation.Contact !== null) {
        conversation.Contact.PhotoURL = input.Data.PhotoURL
        conversation.Contact.StatusText = input.Data.StatusText
        conversation.Contact.VisibleName = input.Data.VisibleName
      }
    },

    processWSSetTaskTyping(input) {
      if (input.From === this.$store.state.session.user.UserID) {
        return
      }
      var isTyping = input.Task === 'start_typing'

      var newConvId = ''
      if (input.isGroup) {
        newConvId = input.To
      } else {
        var n = input.From.localeCompare(input.To)
        var merged = n === -1 ? input.From + input.To : input.To + input.From
        newConvId = md5(merged).toString()
      }
      var visiblename = this.$store.getters.getUserById(input.From).VisibleName

      this.$store.dispatch('setConversationContactWriting', {
        from: visiblename,
        id: newConvId,
        state: isTyping,
        isGroup: input.isGroup
      })
    },

    processWSTaskLogin(input) {
      if (input.Data.PhotoURL === null) {
        input.Data.PhotoURL = null //'/images/avatar_flower.png'
      }
      this.$cookies.set('tmpUserData', input.Data)
      this.$store.dispatch('setUser', input.Data)
      EventBus.$emit('log', {
        type: 'task',
        text: 'login'
      })

      EventBus.$emit('SocketOpened')
      EventBus.$emit('reloadUpdatedData')
    },

    processWebSocketReceivedMessage(input) {
      let conv
      if (input.isGroup === true) {
        conv = this.$store.getters.sortedConversations.find(c => c.GroupID === input.To)

        let tempMessageStatus = {}
        tempMessageStatus.DeliverDate = null
        tempMessageStatus.GroupID = input.To
        tempMessageStatus.MessageID = input.MessageID
        tempMessageStatus.SeenDate = null
        tempMessageStatus.Status = 2
        tempMessageStatus.UpdateDate = input.UpdateDate
        tempMessageStatus.UserID = this.$store.state.session.user.UserID
        tempMessageStatus.UniqueID = input.To

        this.$store.state.messagestatus.messageStatuses.push(tempMessageStatus)
      } else if (input.ConversationType === 2) {
        conv = this.$store.getters.sortedConversations.find(c => c.ChannelID === input.To)

        if (input.From !== this.$store.state.session.user.UserID) {
          let tempMessageStatus = {}
          tempMessageStatus.DeliverDate = null
          tempMessageStatus.MessageID = input.MessageID
          tempMessageStatus.SeenDate = null
          tempMessageStatus.Status = 2
          tempMessageStatus.UpdateDate = input.UpdateDate
          tempMessageStatus.UserID = this.$store.state.session.user.UserID
          tempMessageStatus.UniqueID = input.To

          this.$store.state.messagestatus.messageStatuses.push(tempMessageStatus)
        }
      } else {
        conv = this.$store.getters.sortedConversations.find(c => c.ConversationID === input.ConversationID)
      }
      input.Status = 1
      if (input.From !== this.$store.state.session.user.UserID) {
        input.Status = 2
      }
      // eslint-disable-next-line
      if (ifvisible.now() && conv !== undefined && conv.ConversationID === this.$store.state.conversation.activeConversation.ConversationID && input.From !== this.$store.state.session.user.UserID) {
        input.Status = 3
      }
      if (conv === undefined) {
        var newConversation = {
          ConversationID: input.ConversationID,
          CreateDate: moment().format('YYYY-MM-DD HH:mm:ss.SSS'),
          Status: 0,
          isBuddyWriting: false,
          ContactID: input.From,
          Contact: this.$store.getters.getUserById(input.From),
          Messages: [],
          LastMessage: {}
        }
        newConversation.LastMessage = input
        if (input.isGroup === true) {
          newConversation.GroupID = input.To
          newConversation.ConversationID = input.To
          newConversation.isGroupConversation = true
        } else if (input.ConversationType === 2) {
          let sourceChannel = this.$store.state.channel.channels.find(x => x.ChannelID === input.To) || {}
          newConversation = {
            ...sourceChannel,
            ...newConversation,
            ChannelID: input.To,
            ChannelName: sourceChannel.ChannelName,
            ConversationID: input.To,
            isChannelConversation: true
          }
        }

        this.$store.dispatch('addNewConversation', newConversation)
      } else {
        this.$set(conv, 'LastMessage', input)
        this.$store.dispatch('setConversationContactWriting', {
          id: conv.ConversationID,
          state: false
        })
      }

      // eslint-disable-next-line
      if (this.newMessageSound !== undefined && !ifvisible.now()) {
        this.newMessageSound.play()
      }

      this.$store.dispatch('appendMessages', [input])

      var messageState = this.$store.state.messagestatus.messageStatuses.find(x => x.MessageID === input.MessageID && x.UserID === input.From)
      this.updateMessageStatus(input, messageState)

      let element = this.$store.state.conversation.conversations.find(x => x.ConversationID === input.ConversationID)
      if (element !== undefined) {
        let ix = this.$store.state.conversation.conversations.indexOf(element)
        this.$set(this.$store.state.conversation.conversations[ix], 'UnreadMessageCount', this.$store.getters.unreadMessagesCountOfConversation(this.$store.state.conversation.conversations[ix]))
      } else {
        let el = this.$store.state.group.groups.find(x => x.GroupID === input.To)
        if (el !== undefined) {
          let i = this.$store.state.group.groups.indexOf(el)
          this.$set(this.$store.state.group.groups[i], 'UnreadMessageCount', this.$store.getters.unreadMessagesCountOfConversation(this.$store.state.group.groups[i]))
        } else {
          let ch = this.$store.state.channel.channels.find(x => x.ChannelID === input.To)
          let i = this.$store.state.channel.channels.indexOf(ch)
          if (i >= 0) {
            this.$set(this.$store.state.channel.channels[i], 'UnreadMessageCount', this.$store.getters.unreadMessagesCountOfConversation(this.$store.state.channel.channels[i]))
          }
        }
      }

      // this.$set(element, 'UnreadMessageCount', this.$store.getters.unreadMessagesCountOfConversation(element))
    },

    processWSTaskUpdatedData(input) {
      var vm = this

      this.$store.dispatch('setContacts', input.Contacts)

      var conv = input.Conversations
      conv.forEach(element => {
        element.Contact = this.$store.getters.getUserById(element.ContactID)
        element.isBuddyWriting = false
      })

      if (this.$store.state.isFirstLoad) {
        // TODO: burada en önce clear conversation result çağrılıcak.
        this.$store.dispatch('setClearedConversations', input.ClearConversation).then(() =>
          this.$store.dispatch('setMessages', input.Messages).then(() =>
            this.$store
              .dispatch('setMessageStatuses', input.MessageStatuses)
              .then(() => {
                this.processConversationUnreadCount(input.Conversations, input.Groups, input.Channels || [])
              })
              .then(() => this.$store.dispatch('setConversations', input.Conversations))
              .then(() =>
                this.$store
                  .dispatch('setGroups', input.Groups)
                  .then(() => this.$store.dispatch('setChannels', input.Channels || []))
                  .then(() => {
                    vm.$store.state.isFirstLoad = false
                    vm.$nextTick(() => {
                      setTimeout(() => {
                        vm.setDeliverStatusOfConversationMessages()
                      }, 0)
                    })
                  })
              )
          )
        )
      } else {
        var unsentMessages = {
          ...this.$store.state.message.unsentMessages
        }
        if (unsentMessages && unsentMessages.length > 0) {
          input.Messages = input.Messages.concat(unsentMessages)
        }
        this.$store.dispatch('setClearedConversations', input.ClearConversation)
        this.$store.dispatch('setConversations', input.Conversations)
        this.$store.dispatch('setGroups', input.Groups)
        this.$store.dispatch('setChannels', input.Channels || [])
        this.$store.dispatch('setMessages', input.Messages)
        this.$store.dispatch('setMessageStatuses', input.MessageStatuses)
        this.processConversationUnreadCount(input.Conversations, input.Groups, input.Channels || [])
        this.$store.dispatch('setConversations', input.Conversations)
      }
    },
    processGetSettings(input) {
      var vm = this
      if (input.UserSettings === '') {
        return
      }
      this.$store.state.conversation.userSettings = JSON.parse(input.UserSettings)
      var pinnedConversations = JSON.parse(input.UserSettings)
      if (pinnedConversations.Pins.length > 0) {
        for (const pinnedConversation of pinnedConversations.Pins) {
          if (pinnedConversation.isGroup === true) {
            var conv = vm.$store.state.group.groups.find(x => x.GroupID == pinnedConversation.UniqueID)
            if (conv != null) {
              vm.$set(conv, 'isPinned', true)
              vm.$set(conv, 'pinCreateDate', pinnedConversation.CreateDate)
            } else {
              var channel = vm.$store.state.channel.channels.find(x => x.ChannelID == pinnedConversation.UniqueID)
              if (channel != null) {
                vm.$set(channel, 'isPinned', true)
                vm.$set(channel, 'pinCreateDate', pinnedConversation.CreateDate)
              }
            }
          } else {
            var conv2 = vm.$store.state.conversation.conversations.find(x => x.ConversationID == pinnedConversation.UniqueID)
            if (conv2 != null) {
              vm.$set(conv2, 'isPinned', true)
              vm.$set(conv2, 'pinCreateDate', pinnedConversation.CreateDate)
            }
          }
        }
      }
    },
    processGetStars(input) {
      var vm = this
      this.$store.state.message.starredMessages = input.Messages
      for (const iterator of this.$store.state.message.starredMessages) {
        var item = this.$store.state.message.messages.find(x => x.MessageID === iterator.MessageID)
        if (item !== undefined) {
          this.$set(item, 'isStarredMessage', true)
          // item.isStarredMessage = true
        }
      }
    },
    processWSSetUpdateMessageStatus(input) {
      var MessageID = input.MessageID
      let messageStates = this.$store.state.messagestatus.messageStatuses.find(ms => ms.UserID === input.UserID && ms.MessageID === input.MessageID)
      if (messageStates !== undefined) {
        this.$set(messageStates, 'Status', input.Status)
      }
      var message = this.$store.state.message.messages.find(x => x.MessageID === MessageID)
      if (message !== undefined) {
        this.$set(message, 'Status', input.Status)
      }
    },
    processWSSetDeleteMessage(input) {
      var MessageID = input.MessageID
      let messageStates = this.$store.state.messagestatus.messageStatuses.find(ms => ms.UserID === input.UserID && ms.MessageID === input.MessageID)
      if (messageStates !== undefined) {
        this.$set(messageStates, 'Status', input.DeleteStatus)
      }
      var message = this.$store.state.message.messages.find(x => x.MessageID === MessageID)
      if (message !== undefined) {
        this.$set(message, 'Status', input.DeleteStatus)
      }
    },
    processWSSetDeleteMessages(input) {
      // var MessageID = input.MessageID
      let messageStates = this.$store.state.messagestatus.messageStatuses.find(ms => ms.UserID === input.UserID && ms.MessageID === input.MessageID)
      if (messageStates !== undefined) {
        this.$set(messageStates, 'Status', input.DeleteStatus)
        this.$set(messageStates, 'DeleteStatus', input.DeleteStatus)
      }
      for (const iterator of input.Messages) {
        var message = this.$store.state.message.messages.find(x => x.MessageID === iterator.MessageID)
        if (message !== undefined) {
          this.$set(message, 'Status', input.DeleteStatus)
          this.$set(message, 'DeleteStatus', input.DeleteStatus)
        }
      }
    },
    processWSSetEditMessage(input) {
      var MessageID = input.MessageID
      var message = this.$store.state.message.messages.find(x => x.MessageID === MessageID)
      if (message !== undefined) {
        // Şifre çözme (dm mantığı)
        var decryptedBody = input.Body
        if (this.$store.state.ien && input.Body) {
          try {
            var key, iv
            if (message.mv === 2) {
              // mv=2: karmaşık key
              var last1Char = MessageID.charAt(MessageID.length - 1)
              var last2Char = MessageID.charAt(MessageID.length - 2)
              var last1 = last1Char.charCodeAt(0) % 5
              var last2 = last2Char.charCodeAt(0) % 5
              var parts = MessageID.split('-')
              key = message.From + parts[last1] + parts[last2] + 'da81b159-a8d1-4f56-90b7-914d1a561bb0' + message.To
            } else {
              // mv!=2: basit key
              key = message.From + message.To
            }
            iv = key.split('').reverse().join('')
            decryptedBody = this.dwk(input.Body, key, iv)
          } catch (e) {
            console.log('Edit message decrypt failed', e)
          }
        }
        this.$set(message, 'Body', decryptedBody)
        this.$set(message, 'IsEdited', true)
        this.$set(message, 'Mentions', Array.isArray(input.Mentions) ? input.Mentions : [])
      }
    },
    processWSSetToggleReaction(input) {
      var message = this.$store.state.message.messages.find(x => x.MessageID === input.MessageID)
      if (message === undefined) return

      // Reactions dizisi yoksa oluştur (Vue reactivity için $set)
      if (message.Reactions === undefined) {
        this.$set(message, 'Reactions', [])
      }

      if (input.Action === 'added') {
        // Bir kullanıcının tek bir tepkisi olabilir: aynı kullanıcının mevcut tepkilerini temizle
        var nextReactions = message.Reactions.filter(r => r.UserID !== input.UserID)
        nextReactions.push({
          UserID: input.UserID,
          Emoji: input.Emoji,
          CreateDate: new Date().toISOString()
        })
        this.$set(message, 'Reactions', nextReactions)
      } else if (input.Action === 'removed') {
        // İlgili tepkiyi filtrele (yeni referans ile reaktiviteyi garantile)
        var remaining = message.Reactions.filter(r => !(r.UserID === input.UserID && r.Emoji === input.Emoji))
        this.$set(message, 'Reactions', remaining)
      }
    },
    processConversationUnreadCount(conversations, groups, channels = []) {
      const directCounts = new Map()
      const sharedCounts = new Map()
      const userId = this.$store.state.session.user.UserID

      const incrementCount = (counts, key) => {
        counts.set(key, (counts.get(key) || 0) + 1)
      }

      for (const message of this.$store.state.message.messages) {
        if (!(message.Status < 3) || message.From === userId) {
          continue
        }

        incrementCount(sharedCounts, message.To)
        if (message.MessageType !== 7) {
          incrementCount(directCounts, message.ConversationID)
        }
      }

      for (const element of conversations) {
        this.$set(element, 'UnreadMessageCount', directCounts.get(element.ConversationID) || 0)
      }
      for (const iterator of groups) {
        this.$set(iterator, 'UnreadMessageCount', sharedCounts.get(iterator.GroupID) || 0)
      }
      for (const iterator of channels) {
        this.$set(iterator, 'UnreadMessageCount', sharedCounts.get(iterator.ChannelID) || 0)
      }
    },
    processWSSetTaskUpdateConversation(input) {
      let UniqueID = input.UniqueID
      let UserID = input.UserID
      let newStatus = input.Status

      if (input.isGroup || input.ConversationType === 2) {
        let messageStatuses = this.$store.state.messagestatus.messageStatuses.filter(ms => ms.UniqueID === UniqueID && ms.UserID === UserID && ms.Status < 3)

        messageStatuses.forEach(ms => {
          ms.Status = newStatus
        })
      } else {
        let messages = this.$store.state.message.messages.filter(m => m.ConversationID === UniqueID && m.Status < 3)

        messages.forEach(m => {
          m.Status = newStatus
        })
      }
      // let element = this.$store.state.conversation.conversations.find(x=>x.ConversationID === input.ConversationID)
      // let ix = this.$store.state.conversation.conversations.indexOf(element)
      // let ix2 = this.$store.state.conversation.conversations.indexOf(element)
      // this.$store.state.conversation.conversations[ix].UnreadMessageCount = this.$store.getters.unreadMessagesCountOfConversation(this.$store.state.conversation.conversations[ix])
      // this.$set(element, 'UnreadMessageCount', this.$store.getters.unreadMessagesCountOfConversation(element))
    }
  }
}
